//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    isline: {
      // 是否折行样式
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      hotdata: []
    }
  },
  mounted () {
    this.getdata()
  },
  methods: {
    getdata () {
      this.$api.home
        .invokev3(
          {},
          {
            Routes: 'search$statisticsHotSearch'
          }
        )
        .then((res) => {
          const arr = res.search.statisticshotsearch.data ? res.search.statisticshotsearch.data : []
          this.hotdata = [...arr]
        })
    },
    todealer (item) {
      this.$api.home
        .invokev3(
          {
            code: item.code,
            keyword: item.showName,
            url: this.$store.state.allHost,
            userAgent: navigator.userAgent,
            userId: this.$store.state.user.userId ? this.$store.state.user.userId : this.$Cookie.get('wiki-bfp')
          },
          {
            Routes: 'search$statisticsupload'
          }
        )
        .then((res) => {
          console.log(res, 11123)
        })
      window.open(`https://www.${this.$store.state.newhost}.com/${this.$store.state.LanguageCode}/dealer/${item.code}.html`)
    }
  }
}
